<div class="title">
  <h2>{{ config.header.title | translate }}</h2>
  <button mat-mini-fab color="accent" (click)="config.header.actions[0].onClick()" *ngIf="config.header.actions.length === 1 && (!config.addFamilyType || !manageFamily)">
    <mat-icon>add</mat-icon>
  </button>
  <button mat-mini-fab color="accent" [matMenuTriggerFor]="menu" *ngIf="config.header.actions.length > 1 || (config.header.actions.length === 1 && config.addFamilyType && manageFamily)">
    <mat-icon>add</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <a *ngFor="let action of config.header.actions" (click)="action.onClick()" mat-menu-item>
      {{ action.label | translate }}
    </a>
    <a *ngIf="config.addFamilyType && manageFamily" (click)="addNewFamily()" mat-menu-item> {{ 'ressource_list_create_family' | translate }} </a>
  </mat-menu>
</div>

<p *ngIf="config.header.description">{{ config.header.description | translate }}</p>

<mat-form-field appearance="fill" class="sort-field" *ngIf="config.header.filters.length > 0">
  <span matPrefix>
    <mat-icon>swap_vert</mat-icon>
  </span>
  <mat-select panelClass="long-panel" [(ngModel)]="selectedFilterValue" (selectionChange)="onFilterChange($event.value)">
    <mat-option *ngFor="let filter of config.header.filters" [value]="filter.value">
      {{ filter.label | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>

<div class="row">
  <div class="col">
    <mat-form-field appearance="fill" class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <mat-label>{{ 'ressource_list_filter_by_name' | translate }}</mat-label>
      <input #filterInput matInput (input)="onNameChanged(filterInput.value)" />
    </mat-form-field>
  </div>
</div>

<div class="nav-scroll" [class.selection-mode]="hasSelectionActions && getSelectedRessourcesCount() > 0">
  <div class="sticky-actions" *ngIf="hasSelectionActions && getSelectedRessourcesCount() > 0">
    <div class="sticky-actions-content">
      <div class="action-buttons">
        <button mat-raised-button color="primary" (click)="onShareClick()" [disabled]="!canShare">{{ 'action_bar_share' | translate }}</button>
        <button mat-raised-button color="warn" (click)="onDeleteClick()" [disabled]="!canDelete">{{ 'action_bar_delete' | translate }}</button>
      </div>
    </div>
  </div>

  <cdk-tree class="cdk-tree" [dataSource]="config.dataSource" [treeControl]="treeControl">
    <cdk-nested-tree-node *cdkTreeNodeDef="let node" class="tree-node">
      <ng-container *ngIf="getItemConfig(node) as itemConfig">
        <div class="node-item" [class.selection-list]="hasSelectionActions" [class.selection-enabled]="hasSelectionActions && isItemDeletable(node, itemConfig)">
          <div class="col-1" *ngIf="itemConfig.showBadge !== false || (hasSelectionActions && isItemDeletable(node, itemConfig))">
            <mat-checkbox *ngIf="hasSelectionActions && isItemDeletable(node, itemConfig)" class="hover-checkbox" [checked]="isRessourceSelected(node)" (change)="onRessourceSelectionChange(node)" disableRipple></mat-checkbox>
            <badge-statut class="badge-statut" [itemType]="itemConfig.itemType" [item]="node"></badge-statut>
          </div>
          <span [routerLink]="itemConfig.url" routerLinkActive="item-active" [state]="itemConfig.state">
            {{ itemConfig.displayName }}
            <mat-icon class="fav-star" *ngIf="node?.isFavorite">star</mat-icon>
          </span>
        </div>
      </ng-container>
    </cdk-nested-tree-node>

    <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: hasChild" class="tree-node">
      <ng-container *ngIf="node.type == 2 && !node.isCategory && node.url && getItemConfig(node) as itemConfig; else plainTitle">
        <!-- Ressource à sous-éléments (ex. usine à formules) : rendue exactement comme une ressource-
             feuille (.node-item + pastille), hors du style .tree-node-title réservé aux familles ;
             seul le chevron s'ajoute à droite. Un nœud de regroupement (sans url) reste un en-tête
             via #plainTitle. -->
        <div class="tree-node-row">
          <div class="node-item" [class.selection-list]="hasSelectionActions">
            <div class="col-1" *ngIf="itemConfig.showBadge !== false">
              <badge-statut class="badge-statut" [itemType]="itemConfig.itemType" [item]="node"></badge-statut>
            </div>
            <span cdkTreeNodeToggle [routerLink]="node.url" routerLinkActive="item-active">
              {{ node.key }}
              <mat-icon class="fav-star" *ngIf="node?.isFavorite">star</mat-icon>
            </span>
          </div>
          <div class="btn-actions">
            <button mat-icon-button [attr.aria-label]="'Toggle ' + node.key" cdkTreeNodeToggle *ngIf="node.value && node.value.length > 0">
              <mat-icon class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-template #plainTitle>
        <!-- Famille / catégorie : toute la ligne bascule l'ouverture (cdkTreeNodeToggle sur le
             conteneur), pas seulement le texte, pour une zone de clic cohérente avec le survol. -->
        <div class="tree-node-title" cdkTreeNodeToggle>
          <span [ngClass]="{ 'tree-node-subtitle': node.type == 2 && !node.isCategory, 'tree-node-category': node.isCategory }" *ngIf="!node.url">{{ node.key }}</span>
          <span [ngClass]="{ 'tree-node-subtitle': node.type == 2 && !node.isCategory, 'tree-node-category': node.isCategory }" *ngIf="node.url" [routerLink]="node.url">{{ node.key }}</span>
          <div class="btn-actions">
            <button mat-icon-button [attr.aria-label]="'Toggle ' + node.key" *ngIf="node.value && node.value.length > 0">
              <mat-icon class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>
            <mat-icon *ngIf="manageFamily && config.getEditableFamilyId && config.getEditableFamilyId(node)" class="edit-family" (click)="editFamily(node); $event.stopPropagation()">edit</mat-icon>
          </div>
        </div>
      </ng-template>

      <div *ngIf="treeControl.isExpanded(node)">
        <ng-container cdkTreeNodeOutlet></ng-container>
      </div>
    </cdk-nested-tree-node>
  </cdk-tree>
</div>
